<template>
  <b-badge :class="classModifier" variant="none" data-cy="lead-stage-badge">{{
    $t(`lead.stage.${stageId}`)
  }}</b-badge>
</template>

<script>
export default {
  name: "LeadStageBadge",
  props: {
    stageId: Number
  },
  computed: {
    classModifier() {
      switch (this.stageId) {
        case 100:
          return "border border-info text-info badge-pill";
        case 200:
          return "border border-warning text-warning badge-pill";
        case 300:
          return "border border-primary text-primary badge-pill";
        case 400:
          return "border border-danger text-danger badge-pill";
        case 500:
          return "border border-success text-success badge-pill";
        default:
          return "outline-danger";
      }
    }
  }
};
</script>

<style>
</style>
